import type { ReactNode } from "react";
import type { NormalizedTool, ToolAccess } from "@/lib/toolStack";
import { cn } from "@/lib/utils";

export const ACCESS_LABEL: Record<ToolAccess, string> = {
  included: "Included",
  discounted: "Discounted",
  agent_paid: "Agent-paid",
};

/** v3 tag chip: DM Mono, radius 4, hairline border. Never a pill, never gold. */
export function SpecTag({ children }: { children: ReactNode }) {
  return (
    <span className="inline-flex items-center rounded-[4px] border border-border px-1.5 py-px font-[DM_Mono,ui-monospace,monospace] text-[11px] leading-[18px] text-ink-700">
      {children}
    </span>
  );
}

/** A tool's tags, in a fixed order: access, then Trained. Nothing when it has none. */
export function ToolTags({ tool, className }: { tool: NormalizedTool; className?: string }) {
  if (!tool.access && !tool.trained) return null;
  return (
    <span className={cn("inline-flex flex-wrap items-center gap-1.5", className)}>
      {tool.access && <SpecTag>{ACCESS_LABEL[tool.access]}</SpecTag>}
      {tool.trained && <SpecTag>Trained</SpecTag>}
    </span>
  );
}
